import { render, staticRenderFns } from "./CustomClasses.vue?vue&type=template&id=13ad7c19&"
import script from "./CustomClasses.vue?vue&type=script&lang=js&"
export * from "./CustomClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports